import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-message-search-plate-failed',
  templateUrl: './message-search-plate-failed.component.html',
  styleUrls: ['./message-search-plate-failed.component.sass']
})
export class MessageSearchPlateFailedComponent extends BaseModal implements OnInit {
  public plate;
  isValid = true;

  constructor(
    public modalService: ModalService
  ) {
    super(modalService);
   }

  ngOnInit() {
    this.plate = this.initialState && this.initialState.toUpperCase();
  }

  get lastState(): any {
    return null;
  }

  async onAllSubmited(): Promise<any> { }
}
